import { Typography, Container } from '@mui/material';

const LiensClients = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                Liens clients
            </Typography>
            <Typography>
                Gestion des liens vers les documents des clients. Ajoutez ici la logique de lien.
            </Typography>
        </Container>
    );
};

export default LiensClients;